import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  Badge,
  Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';

class Loader extends Component {

	render() {
	
	return (
      <div style={{textAlign : 'center',fontSize : '20px'}}>
        <i className="fa fa-spinner fa-spin" /> Loading...
      </div>
	 )
	}
}
export default Loader;


// WEBPACK FOOTER //
// ./src/Loader/Loader.js